export function setModalOpened(status) {
  return {
    type: "@modal_waiting_bought/SET_MODAL_OPENED",
    payload: { status },
  };
}
